import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import Layout from '../../components/layout';
import ImportantInformationSection from './_importantInformation';
import { PageContext } from '@/context/PageContext';
import '@/components/PageLayout/pageHeader.css';
import HeroV2 from '@/components/Hero/HeroV2/HeroV2';



function HarveyPage(props) {
  /** Contentful Data */
  const contentfulPageData = useContext(PageContext);
  const state = contentfulPageData?.updatedBody || {};
  /** - END - */

  return (
    <Layout location={props.location}>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.latitudefinancial.com.au/interest-free/harvey-norman/"
        />
        <title>Latitude Interest Free</title>
        <meta name="description" content="Interest Free." />
      </Helmet>

      <main className="navigation-spacer" css="background-color: #f8f8f8;">
        <HeroV2
          {...(state?.heroBannerData?.[0])}
        />
       
        <ImportantInformationSection />
      </main>
    </Layout>
  );
}

export default HarveyPage;
